class LoadingQuestionsScreenController{

    draw(category){
        const color = category.color ?? 'fff';
        $('#loadingContainerDiv').css('background-color','#' + color);
    };
}